import { io } from "socket.io-client";
import { useAuthStore } from "../store/authStore";

let socket = null;

export function getSocketUrl() {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!envUrl) return window.location.origin;
  try {
    const url = new URL(envUrl, window.location.origin);
    return `${url.protocol}//${url.host}`;
  } catch (e) {
    return envUrl;
  }
}

export function initSocket() {
  const { token, activeOrganization } = useAuthStore.getState();

  if (socket) {
    if (token) {
      socket.auth = {
        token: token || "",
        orgId: activeOrganization?._id || activeOrganization?.id || "",
      };
      if (!socket.connected) socket.connect();
    }
    return socket;
  }

  const socketUrl = getSocketUrl();

  socket = io(socketUrl, {
    auth: {
      token: token || "",
      orgId: activeOrganization?._id || activeOrganization?.id || "",
    },
    transports: ["websocket", "polling"],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 15,
    reconnectionDelay: 2000,
  });

  socket.on("connect", () => {
    const currentOrg = useAuthStore.getState().activeOrganization;
    const orgId = currentOrg?._id || currentOrg?.id;
    if (orgId) {
      socket.emit("join_org", orgId);
    }
  });

  return socket;
}

export function getSocket() {
  if (!socket) {
    return initSocket();
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
